"use client";

import { useSyncExternalStore } from "react";
import { subscribeTourVisit, wasTourShownThisVisit } from "@/utils/acknowledgements/tourVisit";

/** True once any guided tour has started in this tab's visit. Always false on the server. */
export function useTourShownThisVisit(): boolean {
  return useSyncExternalStore(subscribeTourVisit, wasTourShownThisVisit, () => false);
}
